module.exports = __webpack_public_path__ + "static/media/dø.1fb676b9.m4a";